import React from 'react';
import * as Render from '../../Base/Render';
import Breadcrumb from '../../Breadcrumb';
import Theme from '../../Theme';

const SectionStartPage = (props) => {
  return (
    <>
      <div className="breadcrumb-container">
        <div className="row">
          <div className="columns">
            <Breadcrumb {...props.Breadcrumbs} Language={props.Language} />
          </div>
        </div>
      </div>
      <main className="main">
        <div className="row"></div>

        <div id="content" dir={props.Dir}>
          <Theme {...props}>
            <Render.Block
              blocks={props.Content.MainContent}
              propertyName="MainContent"
              stylePropertyName="SectionContent"
              currentPageProps={props}
            >
              {props.BlockTypeRenderer}
            </Render.Block>
          </Theme>
        </div>
      </main>
    </>
  );
};

export default SectionStartPage;
